import styled from 'styled-components';
import { StyledSpaceSection } from '../../../SpaceSection/styled';
import { Breakpoints } from '../../../../../styled/constants';
import { Typography } from '../../../../ui/Typography';

export const AuthorManagementBlockWrapper = styled(StyledSpaceSection)`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 10px;
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    border-radius: 14px;
    padding: 30px 20px;
  }
`;

export const ExpiresAtInfo = styled(Typography)`
  display: block;
  text-align: center;
`;
